export const formatPhoneForPayload = (phone: string, withInternationalExtension: boolean = false): string => {
  let result = phone.replace(/ /g, '');
  if (withInternationalExtension && result.charAt(0) !== '+') {
    result = `+61${result.slice(1, result.length)}`;
  }
  return result;
};
